<h2 mat-dialog-title>{{ 'COPY_MATRIX_STOCK_DIALOG.TITLE' | translate }}</h2>

<mat-dialog-content>
  <p class="copy-matrix-stock-dialog-message"
     [id]="messageId">
    {{ 'COPY_MATRIX_STOCK_DIALOG.MESSAGE' | translate }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button
          type="button"
          cdkFocusInitial
          (click)="choose(false)">
    {{ 'COPY_MATRIX_STOCK_DIALOG.NO' | translate }}
  </button>
  <button mat-raised-button
          color="primary"
          type="button"
          (click)="choose(true)">
    {{ 'COPY_MATRIX_STOCK_DIALOG.YES' | translate }}
  </button>
</mat-dialog-actions>
